module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "resume-container"
  }, _vm._l((_vm.resume), function(item) {
    return _c('div', {
      staticClass: "resume-item"
    }, [_c('h3', [_vm._v("\n      " + _vm._s(item.title) + "\n      "), _c('span', {
      staticClass: "period"
    }, [_vm._v("\n        " + _vm._s(item.started) + " - " + _vm._s(item.ended) + "\n      ")])]), _vm._v(" "), _c('h4', [_vm._v("\n      " + _vm._s(item.company) + "\n      "), _c('span', [_vm._v("\n        " + _vm._s(item.companyDescription) + "\n      ")])]), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f309eb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Resume.vue
// module id = 45
// module chunks = 0